export enum ApplicantFilters {
    jobPosting = 'atsJobId',
    status = 'is_archived',
    jobFunnel = 'jobFunnelStepName',
    rating = 'rating',
}
